import React from 'react';
import styles from './AdPurchase.module.scss';
import {MDBTooltip} from 'mdbreact';
import {IProduct} from 'data/interfaces/products';
import {generateSluggedAdUrl} from 'data/redux/actions/guiActions';
import LinkBlockContainer from 'data/redux/containers/linkBlockContainer/LinkBlockContainer';
import AdSavings, {eSavingsType} from './components/adSavings/AdSavings';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';

interface IAdProps {
  product: IProduct;
  loading?: boolean;
  savingsType?: eSavingsType;
}

const AdPurchase = (props: IAdProps) => {
  return (
    <div className={styles.AdPurchase}>

      {props.loading ? <SkeletonPlaceHolder/> : <MDBTooltip
        domElement
        tag="span"
        placement="top"
      >
        <div>
          <LinkBlockContainer
            className={styles.purchaseButton}
            to={generateSluggedAdUrl(props.product)}
          >
            לרכישה
          </LinkBlockContainer>
          <AdSavings product={props.product} savingsType={props.savingsType}/>
        </div>
        <span>עבור לדף המוצר</span>
      </MDBTooltip>}

    </div>
  );
};

AdPurchase.defaultProps = {
  product: {},
};
export default AdPurchase;
